module.exports = __webpack_public_path__ + "img/Group 1119five1.6e4d5519.png";